import React from 'react';
import iconMarketing from '../assets/images/marketing.png';
import iconDress from '../assets/images/dress.png';
import iconCommunity from '../assets/images/community.png';
import iconProject from '../assets/images/project.png';

function About() {
    return (
        <article className="content active" data-page="about">
            <header>
                <h2 className="h2 article-title">Sobre mí</h2>
            </header>
            <section className="about-text">
                <p>
                    Mi nombre es Paola Valle y me especializo en
                    <strong style={{ fontWeight: 700 }}> comunicación, marketing y branding para empresas. </strong>
                    Disfruto aplicando mis habilidades de gestión emocional, lo que me ha llevado a ser
                    asertiva, productiva y colaborativa. Resuelvo problemas con creatividad y lidero con inspiración.
                </p>
            </section>
            <section className="service">
                <h3 className="h3 service-title">Lo que hago</h3>
                <ul className="service-list">
                    <li className="service-item">
                        <div className="service-icon-box">
                            <img src={iconProject} alt="icono project" width="40" />
                        </div>
                        <div className="service-content-box">
                            <h4 className="h4 service-item-title">Project Manager</h4>
                            <p className="service-item-text">
                                Transformo ideas en realidades, gestionando cada proyecto con precisión y pasión para alcanzar el éxito.
                            </p>
                        </div>
                    </li>
                    <li className="service-item">
                        <div className="service-icon-box">
                            <img src={iconCommunity} alt="icono community" width="40" />
                        </div>
                        <div className="service-content-box">
                            <h4 className="h4 service-item-title">Community Manager</h4>
                            <p className="service-item-text">
                                Conecto personas y fortalezco la imagen de tu marca.
                            </p>
                        </div>
                    </li>
                    <li className="service-item">
                        <div className="service-icon-box">
                            <img src={iconDress} alt="icono moda" width="40" />
                        </div>
                        <div className="service-content-box">
                            <h4 className="h4 service-item-title">Consultora de imagen</h4>
                            <p className="service-item-text">
                                Creo identidades visuales impactantes que reflejan la esencia y los valores únicos de tu marca o imagen.
                            </p>
                        </div>
                    </li>
                    <li className="service-item">
                        <div className="service-icon-box">
                            <img src={iconMarketing} alt="icono marketing" width="40" />
                        </div>
                        <div className="service-content-box">
                            <h4 className="h4 service-item-title">Marketing estratégico</h4>
                            <p className="service-item-text">
                                Diseño estrategias de marketing innovadoras que capturan la atención y generan resultados medibles.
                            </p>
                        </div>
                    </li>
                </ul>
            </section>

            {/* 
            <div className="contact blog-posts" data-page="contact">
                <header>
                    <h2 className="h2 article-title">Contacto</h2>
                </header>
                <section className="mapbox" data-mapbox>
                    <figure>
                        <iframe
                            src="https://www.google.com/maps/embed?pb="
                            width="400"
                            height="300"
                            loading="lazy"
                        ></iframe>
                    </figure>
                </section>
                <section className="contact-form">
                    <h3 className="h3 form-title">Formulario de contacto</h3>
                    <form action="#" className="form" data-form>
                        <div className="input-wrapper">
                            <input
                                type="text"
                                name="fullname"
                                className="form-input"
                                placeholder="Nombre"
                                required
                                data-form-input
                            />
                            <input
                                type="email"
                                name="email"
                                className="form-input"
                                placeholder="Email"
                                required
                                data-form-input
                            />
                        </div>
                        <textarea
                            name="message"
                            className="form-input"
                            placeholder="Mensaje"
                            required
                            data-form-input
                        ></textarea>
                        <button className="form-btn" type="submit" disabled data-form-btn>
                            <ion-icon name="paper-plane"></ion-icon>
                            <span>Enviar</span>
                        </button>
                    </form>
                </section>
            </div>
            */}
        </article>
    );
}

export default About;
